import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id FCC195C4-2DB3-45DE-B9D2-4535A63EDB0E
 * name smart-card-reader-outline
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/smart-card-reader-outline.svg
 * tags
 * - Account / User 
 */
export const SmartCardReaderOutlineIcon = createSvgIcon(<><path d="M14.5 8.5A2.5 2.5 0 1 0 17 11A2.5 2.5 0 0 0 14.5 8.5M8.25 6H7V16H8.25C9.91 16 10.75 12.66 10.75 11S9.91 6 8.25 6M19 2H5A2.07 2.07 0 0 0 3 4V18H5V4H19V18H21V4A2.07 2.07 0 0 0 19 2M23 22H1V21A2 2 0 0 1 3 19H21A2 2 0 0 1 23 21Z" /></>, 'SmartCardReaderOutlineIcon');
export default SmartCardReaderOutlineIcon